<!-- @format -->

<button
  type="button"
  [class]="
    orderKey === column
      ? 'non-button sortable-table-column-header sortable-table-column-header--active'
      : 'non-button sortable-table-column-header'
  "
  (click)="sortBy()"
  [attr.aria-sort]="ariaSortValue">
  {{ name | translate }}
  <sis-icon icon="sorter" [color]="'primary'" [iconClass]="orderKey === column && reverse ? 'flip-180' : ''"></sis-icon>
</button>
<div aria-live="polite" class="visually-hidden">
  @if (orderKey === column && (ariaLiveMessage$ | async); as msg) {
    <span id="sorting-guidance-{{ column }}">{{ msg | translate }}</span>
  }
</div>
